import { get, post, payPost, payGet } from '@/utils/fetch';
import { useCallback, useEffect, useState, useRef } from 'react';
import { useLocalStorageState } from 'ahooks';
import { TOKEN_KEY } from '@/utils/cookie';
import { useAuthStore } from '@/utils/store';


export const usePreregist = () => {
  const [showVisa, setShowVisa] = useState(false);
  const {token, setAuthToken} = useAuthStore();
  const [regCdk, setRegCdk] = useState(null);

  const preRegistAction = (callback) => {
    if (token) {
      const activityCode = 'vicland_landing_reservation';
      post('/api/reservation/appointment', {
        activity_code: activityCode,
      }).then(res => {
        const {
          data
        } = res;
        if (data.success) {
          setRegCdk(data?.cdk);
          console.log('success');
        }
        callback?.(data);
      });
    }
  };
  
  return {
    regCdk,
    preRegistAction,
  };
};

export const useGetRewards = () => {
  const [rewards, setRewards] = useState([]);

  const updateRewards = () => {
    get('/api/reservation/reward', {
      activity_codes: ['vicland_landing', 'vicland_landing_reservation'],
    }).then(res => {
      const { data } = res;
      const resArr = [];
      data.reward_records.map(item => {
        const { cdk } = item;
        resArr.push(cdk);
      });
      setRewards(resArr);
    });
  };

  return {
    rewards,
    updateRewards
  };
};

export const useSignIn = () => {
  const [signInCount, setSignInCount] = useState();
  const activityCode = 'vicland_landing';

  const signRequest = (callback) => {
    post('/api/reservation/sign-in', {
      activity_code: activityCode,
    }).then(res => {
      const {
        data,
        code,
      } = res;
      if (code == 0) {
        setSignInCount(data?.count);
        callback();
      }
    });
  };

  const getSignData = () => {
    get('/api/reservation/sign-in', {
      activity_code: activityCode,
    }).then(res => {
      const {
        data,
        code,
      } = res;
      if (code == 0) {
        setSignInCount(data?.count);
      }
    });
  };

  return {
    signRequest,
    getSignData,
    signInCount
  };
};

export const useLottery = () => {
  const [giftCodes, setGiftCodes] = useState([]);
  const activityCode = 'vicland_landing';

  const lotteryPost = ({count, callback}) => {
    post('/api/lottery/draw', {
      activity_code: activityCode,
      draw_count: count
    }).then(res => {
      const {
        data,
        code,
      } = res;
      if (code == 0) {
        setGiftCodes(data?.awards);
        callback(data?.awards);
      }
    }).catch(err => {
      callback();
    });
  };

  return {
    lotteryPost,
    giftCodes,
  };
};

export const useLotteryCount = () => {
  const [remainCount, setRemainCount] = useState(0);
  const activityCode = 'vicland_landing';
  const [, setToken] = useLocalStorageState(TOKEN_KEY, {listenStorageChange: true});
  const {setAuthToken} = useAuthStore();

  const updateLotteryCount = () => {
    get('/api/lottery', {
      activity_code: activityCode,
    }).then(res => {
      const {
        data,
        code,
      } = res;
      if (code == 0) {
        setRemainCount(data?.remain_count);
      }
    }).catch(err => {
      const { code } = err;
      if (code == 401) {
        setAuthToken(null);
        setToken('');
      } 
    });
  };

  return {
    remainCount,
    updateLotteryCount
  };
};

export const useInviteFriend = () => {
  const [inviteCode, setInviteCode] = useState(null);
  const activityCode = 'vicland_landing';

  const getInviteCode = () => {
    get('/api/reservation/share-code', {
      activity_code: activityCode,
    }).then(res => {
      const {
        data,
        code,
      } = res;
      if (code == 0) {
        setInviteCode(data?.code);
      }
    });
  };

  const verifyInviteCode = (shareCode) => {
    post('/api/reservation/share-code', {
      activity_code: activityCode,
      share_code: shareCode,
    }).then(res => {
      const {
        data,
        code,
      } = res;
      if (code == 0) {
        setRemainCount(data?.remain_count);
      }
    });
  };

  return {
    inviteCode,
    getInviteCode,
    verifyInviteCode
  };
};

export const useVerifyAccount = () => {
  const [roleId, setRoleId] = useState(null);
  const [levelCount, setLevelCount] = useState(0);
  const activityCode = 'vicland_landing';
  const verifyAccount = ({roleId, callback}) => {
    post('/api/lottery/verify-account', {
      activity_code: activityCode,
      role_id: roleId,
    }).then(res => {
      const {
        data,
        code,
      } = res;
      if (code == 0) {
        callback(data);
        if (data?.level == 2) {
          setLevelCount(30);
        } else if (data?.level == 1) {
          setLevelCount(10);
        }
      }
    });
  };

  const getVerifyAccount = () => {
    get('/api/lottery/verify-account', {
      activity_code: activityCode,
    }).then(res => {
      const {
        data,
        code,
      } = res;
      if (code == 0) {
        if (data?.role_id && data?.role_id != 0) {
          setRoleId(data?.role_id);
        }
      }
    });
  };

  return {
    roleId,
    levelCount,
    verifyAccount,
    getVerifyAccount,
  };
};